import { Component, computed, inject, Signal } from '@angular/core';
import { TextSizeService } from '@core/text-size/services/text-size.service';
import { ButtonDirective, DcRangeValue, RangeSliderComponent, TypographyDirective } from '@dartcounter/ui';
import { TranslateModule } from '@ngx-translate/core';
import { SlideDialogLayoutComponent } from 'src/app/shared/dialogs/slide-dialog-layout/slide-dialog-layout.component';
import { ModalService } from 'src/app/shared/services/modal.service';

export type TextSizePreferenceDialogPayload = Record<string, never>;
export type TextSizePreferenceDialogResponse = void;

@Component({
    selector: 'app-text-size-preference-dialog',
    standalone: true,
    imports: [TranslateModule, SlideDialogLayoutComponent, TypographyDirective, RangeSliderComponent, ButtonDirective],
    templateUrl: './text-size-preference.dialog.html',
})
export class TextSizePreferenceDialogComponent {
    private modalService: ModalService = inject(ModalService);
    private textSizeService: TextSizeService = inject(TextSizeService);

    public readonly textSizePercentage: Signal<number> = computed(() => this.textSizeService.percentage());

    public readonly minimumTextSize: number = this.textSizeService.minimumPercentage;
    public readonly maximumTextSize: number = this.textSizeService.maximumPercentage;
    public readonly textSizeStep: number = this.textSizeService.percentageStep;
    public readonly defaultTextSize: number = this.textSizeService.defaultPercentage;

    public changeTextSize(value: DcRangeValue): void {
        if (typeof value === 'number') this.textSizeService.setPercentage(value);
    }

    public resetTextSize(): void {
        this.textSizeService.reset();
    }

    public dismiss(): void {
        this.modalService.dismiss();
    }
}
